import { render, staticRenderFns } from "./Soja2022DesmatamentoInfonaParaguai.vue?vue&type=template&id=6d2a01f6&lang=pug"
import script from "./Soja2022DesmatamentoInfonaParaguai.vue?vue&type=script&lang=js"
export * from "./Soja2022DesmatamentoInfonaParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports